module.exports = "/_next/static/images/video_id_7169209100465917230-b30e0b62634de32f9158ef4502620d2d.jpg";